export default __webpack_public_path__ + "static/media/img-6.5787be84.png";